import EfSpec from '@elem/ui/ef-spec';
import { useRouter } from 'next/router';
import styles from './ProductContent.module.scss';
import A from './comps/A';
import B from './comps/B';
import B_PH from './comps/B_PH';
import C from './comps/C';
import D from './comps/D';
import D_PH from './comps/D_PH';
import E from './comps/E';
import EU1 from './comps/EU1';
import EU2 from './comps/EU2';
import F from './comps/F';
import F_PH from './comps/F_PH';
import FootTc from './comps/FootTc';
import G from './comps/G';
// import H from './comps/H';
import H_PH from './comps/H_PH';
import I from './comps/I';
import J from './comps/J';
import K from './comps/K';
import L from './comps/L';
import L_PH from './comps/L_PH';
import M from './comps/M';
import N from './comps/N';
import NA1 from './comps/NA1';
import NA2 from './comps/NA2';
import NA3 from './comps/NA3';
import NA4 from './comps/NA4';
// import O from './comps/O';
// import P from './comps/P';
import Q from './comps/Q';
import JA from './compsJP/JA';
import JB from './compsJP/JB';
import JC from './compsJP/JC';
import JD from './compsJP/JD';
import JE from './compsJP/JE';
import JF from './compsJP/JF';
import JG from './compsJP/JG';
import JH from './compsJP/JH';
import JI from './compsJP/JI';
import JJ from './compsJP/JJ';
import JK from './compsJP/JK';
import JL from './compsJP/JL';
import JM from './compsJP/JM';
import JN from './compsJP/JN';
import JO from './compsJP/JO';

export default function Teaser({ bundles, cards2 }: any) {
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca', 'br', 'mx'].includes(locale ?? '');
    const IS_EU_SITES = ['eu', 'de', 'fr', 'it', 'es', 'uk', 'nl'].includes(locale ?? '');

    const RenderPageContent = () => {
        if (locale === 'jp') {
            return (
                <div className="dp3-page-jp">
                    <div style={{ background: '#F2F0E9' }}>
                        <JA />
                        <JB />
                        <JC />
                        <JD />
                        <JE />
                        <JF />
                        <JG />
                    </div>
                    <JH />
                    <JI />
                    <JJ />
                    <JK />
                    <JL />
                    <JM />
                    <JN cards={cards2} />
                    <JO bundles={bundles} />
                    <Q />
                </div>
            );
        }
        if (IS_NA_SITES) {
            return (
                <>
                    <A />
                    <NA1 />
                    <NA2 />
                    <B />
                    <C />
                    <NA4 />
                    <D />
                    <div className="bg-black">
                        <E />
                        <F />
                        <K />
                        <NA3 />
                    </div>
                    <I />
                    <L />
                    <M />
                    <G />
                    <J />
                    <EU1 />
                    <N />
                    <EfSpec className="spec-x" />
                    <Q />
                </>
            );
        }
        if (IS_EU_SITES) {
            return (
                <>
                    <A />
                    <B />
                    <NA1 />
                    <C />
                    <D />
                    <div className="bg-black">
                        <E />
                        <F />
                        <J />
                        <NA3 />
                    </div>
                    <I />
                    {!['nl'].includes(locale) && <EU2 />}
                    <K />
                    <G />
                    <L />
                    {!['nl'].includes(locale) && <EU1 />}
                    <N />
                    <Q />
                    <FootTc />
                </>
            );
        }
        if (locale === 'ph') {
            return (
                <>
                    <A />
                    <B_PH />
                    <NA1 />
                    <C />
                    <D_PH />
                    <E />
                    <F_PH />
                    <J />
                    <H_PH />
                    <I />
                    <EU2 />
                    <K />
                    <G />
                    <L_PH />
                    <EU1 />
                    <N />
                </>
            );
        }
        return null;
    };
    return (
        <div className={styles.teaser}>
            <RenderPageContent />
        </div>
    );
}
